import React from 'react';

import Authenticated from 'Components/Layouts/Fragrance/Authenticated';

export default class TopMenuSettingsLayout extends Authenticated {

}